import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import { motion } from 'framer-motion';
import { FaCheckCircle } from "react-icons/fa";
import { FaRupeeSign, FaUserFriends, FaExclamationTriangle } from "react-icons/fa";
import {
    FaMoneyCheckAlt,
    FaPercentage,
    FaCalendarAlt,
    FaFileInvoiceDollar,
    FaUnlockAlt,
    FaIdCard,
    FaClock,
    FaExchangeAlt,
  } from "react-icons/fa";
  import {
    FaRegCreditCard,
    FaBriefcase,
    FaBalanceScale,
    FaHome,
    FaFileAlt,
    FaHandshake,
    FaUniversity,
    FaFileSignature,
  } from "react-icons/fa";
  import {
  FaChartBar,
  FaHandsHelping,
  FaCalculator,
  FaBookOpen,
  FaSlidersH,
  FaRegComments,
} from "react-icons/fa";
import AdBanner from '../AdPage/AdBanner';
  
const LoanInsuranceNewUiHome = () => {
  function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
    const [activeIndexNew, setActiveIndexNew] = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < 768); // Tailwind's md breakpoint
      };
      handleResize();
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    const toggleAccordionNew = (index) => {
      setActiveIndexNew((prev) => (prev === index ? null : index));
    };
  
    const renderParagraphs = (content) =>
      content.split('\n').map((para, i) => {
        const match = para.match(/^([\w\s']+?):\s*(.*)/);
        return (
          <p key={i} className="text-gray-700 mb-3 whitespace-pre-line">
            {match ? (
              <>
                <span className="font-semibold text-blue-700">{match[1]}:</span>{' '}
                {match[2]}
              </>
            ) : (
              para
            )}
          </p>
        );
      });
    const faqs = [
        {
            question: ' What is a loan?',
            answer:
                'A loan is borrowed money that must be repaid with interest over a set period. The borrower receives a principal amount and pays back the loan amount plus interest.',
        },
        {
            question: 'How do I qualify for a loan?',
            answer:
                'Qualification factors include credit score, income, employment status, and debt-to-income ratio.',
        },
        {
            question: '   What is an interest rate?',
            answer:
                'The interest rate is the percentage of the loan amount charged as the cost of borrowing. It can be fixed (unchanging) or variable (fluctuating).',
        },
        {
            question: 'What is a loan term?',
            answer:
                '  The loan term is the length of time over which you will repay the loan, such as 15 or 30 years.',
        },
        {
          question: 'How does loan repayment work?',
          answer:
              'Repayments are made in regular instalments that include both principal and interest.',
      },
      {
        question: 'Can I repay my loan early?',
        answer:
            'Yes, but check for any prepayment penalties that might apply.',
    },
    {
      question: 'How do I apply for a loan?',
      answer:
          'Apply through a bank, credit union, or online lender by submitting an application and required documents.',
  },
  {
    question: 'What is the difference between a secured and unsecured loan?',
    answer:
        ' A secured loan requires collateral such as property, gold, or a vehicle, while an unsecured loan does not. Secured loans usually offer lower interest rates due to lower risk for lenders, whereas unsecured loans carry higher rates but are easier to access without assets.',
},
{
    question: 'What is a credit score and why is it important for loans?',
    answer:
        'A credit score reflects your creditworthiness based on your past repayment behavior. Lenders use it to assess your risk level. A higher score increases your chances of loan approval and may also help you get better interest rates.',
},
{
    question: 'How is EMI calculated for a loan?',
    answer:
        'EMI (Equated Monthly Installment) is calculated using the loan amount, interest rate, and loan tenure. It includes both principal and interest components and remains fixed for most types of loans unless you opt for a floating rate.',
},
{
    question: 'Can I transfer my loan to another bank?',
    answer:
        'Yes, you can transfer your existing loan to another lender for better interest rates or terms. This process is called a balance transfer and may involve additional documentation, processing fees, and approval based on eligibility.',
},
{
    question: 'What is loan pre-approval?',
    answer:
        ' Loan pre-approval is a process where the lender assesses your eligibility and conditionally approves a loan even before you finalize the purchase (such as for a home or car). It helps you understand your borrowing capacity in advance.',
},
{
    question: 'Do I need a guarantor for getting a loan?',
    answer:
        ' A guarantor may be required if your credit score is low or your income is insufficient. The guarantor assures the lender that they will repay the loan if you default, making it easier for you to get approved.',
},
{
    question: 'What are processing fees in a loan?',
    answer:
        ' Processing fees are charges levied by the lender to cover the cost of processing your loan application. These fees vary by lender and are usually a small percentage of the loan amount, payable upfront or deducted from the disbursed amount.',
},
{
    question: 'Can self-employed individuals get a loan?',
    answer:
        '  Yes, self-employed individuals can apply for loans, but they must provide income proof such as ITRs, bank statements, and business financials. Loan terms may differ slightly compared to salaried applicants due to income variability.',
},
{
    question: 'What happens if I miss a loan EMI payment?',
    answer:
        '  Missing an EMI can lead to late fees, higher interest charges, and a drop in your credit score. If you miss multiple payments, the lender may initiate legal recovery or seize collateral in the case of secured loans.',
},
{
    question: 'Is it better to take a fixed or floating interest rate loan?',
    answer:
        ' Fixed interest rates remain constant throughout the loan term, offering stability in EMIs. Floating rates vary with market conditions, which can be beneficial if rates fall. The best option depends on your risk tolerance and financial goals.',
},
    ];
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
    const cardDataS = [
        {
          imageUrl: '/assets/idfc11.jpg',
          type: 'Car Loan',
          title: 'IDFC First Bank',
          premiumStarting: '9.99%',
          claimSettlement: '₹2Cr',
          networkGarages:"₹2000+ GST",
          learnMoreLink: '/car-loan/idcf-first-bank',
          applyNowLink: 'https://www.idfcfirstbank.com/personal-banking/loans/car-loan'
        },
        {
            imageUrl: '/assets/pnb.jpg',
            title: 'Punjab National Bank',
            premiumStarting: '8.85%',
            claimSettlement: '₹25L',
            networkGarages:"₹500+ GST",
            learnMoreLink: '/gold-loan/punjab-national-bank',
            applyNowLink: 'https://www.pnbindia.in/advance-against-sovereign-gold-bond.html',
            type: 'Gold Loan',
          },
          {
            imageUrl: '/assets/sbi11.png',
            title: 'State Bank of India',
            premiumStarting: '8.25%',
            claimSettlement: '₹5Cr',
            networkGarages:"₹2000+ GST",
            learnMoreLink: '/home-loan/state-bank-of-india-home-loan',
            applyNowLink: 'https://homeloans.sbi/',
            type: 'Home Loan',
          },
          {
            imageUrl: '/assets/canara.png',
            title: 'Canara Bank',
            premiumStarting: '10.70%',
            claimSettlement: '₹30L',
            networkGarages:"₹1000+ GST",
            learnMoreLink: '/personal-loan/canara-bank',
            applyNowLink: 'https://canarabank.com/canara-budget',
            type: 'Personal Loan',
          },
          {
            imageUrl: '/assets/kotak.png',
            title: 'Kotak Mahindra Bank',
            premiumStarting: '16%',
            claimSettlement: '₹1Cr',
            networkGarages:"₹2%",
            learnMoreLink: '/business-loan/kotak-mahindra-bank',
            applyNowLink: 'https://www.kotak.com/en/business/loans/business-loan.html',
            type: 'Business Loan',
          },
          {
            imageUrl: '/assets/bank.png',
            title: 'Bank of India',
            premiumStarting: '10.85%',
            claimSettlement: '₹1.5Cr',
            networkGarages:"₹5000+ GST",
            learnMoreLink: '/education-loan/bank-of-india-education-loan',
            applyNowLink: 'https://bankofindia.co.in/education-loan',
            type: 'Education Loan',
          },
          {
            imageUrl: '/assets/icicinew.png',
            title: 'ICICI Bank',
            premiumStarting: '10.85%',
            claimSettlement: '₹3Cr',
            networkGarages:"₹2%",
            learnMoreLink: '/two-wheeler-loan/icici-bank',
            applyNowLink: 'https://www.icicibank.com/business-banking/finance',
            type: 'TwoWheeler Loan',
          },
        // Add more card data objects here for additional cards
      ];
      const renderCardDetails = (card) => {
        if (card.type === 'Car Loan') {
          return (
            <>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
            </>
          );
        } else if (card.type === 'Gold Loan') {
          return (
            <>
               <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
            </>
          );
        } else if (card.type === 'Home Loan') {
          return (
            <>
                <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
            </>
          );
        } else if (card.type === 'Personal Loan') {
            return (
              <>
                  <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
              </>
            );
        } else if (card.type === 'Business Loan') {
            return (
              <>
               <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
              </>
            );
        } else if (card.type === 'Education Loan') {
            return (
              <>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
              </>
            );
        } else if (card.type === 'TwoWheeler Loan') {
            return (
              <>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Interest Rate:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Loan Amount:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Processing Fee:</strong> {card.networkGarages}</p>
              </>
            );
        } else {
          return null;
        }
      };
      const loanData = [
        {
          title: 'Car Loans',
          content: `A car loan is a type of secured loan that helps you finance the purchase of a new or used vehicle. The loan is secured against the car you intend to purchase, meaning if you default on repayments, the lender has the right to seize the vehicle. Car loans are typically available for various loan amounts, depending on the value of the car and the borrower’s financial profile.
      
      Loan Amount: Varies from a few thousand to several lakhs, depending on the cost of the car and the borrower’s eligibility.
      
      Interest Rates: Generally lower compared to unsecured loans, as the car acts as collateral.
      
      Repayment Terms: Usually, car loans come with a repayment period ranging from 1 to 7 years, providing flexibility in terms of monthly installments.
      
      Why It's Important: Car loans allow you to make large purchases without having to pay the full price upfront, making vehicle ownership more accessible to many. It also helps build your credit score if repaid on time.`,
        },
        {
          title: 'Gold Loans',
          content: `A gold loan is a type of secured loan where you pledge your gold ornaments or gold coins as collateral in exchange for a loan. Gold loans are typically short-term loans that provide quick access to funds for emergency needs, business requirements, or personal expenses.
      
      Loan Amount: Generally offered based on the value of the gold pledged, with loan amounts typically ranging from a few thousand to several lakhs.
      
      Interest Rates: Relatively lower than unsecured loans due to the presence of collateral (gold).
      
      Repayment Terms: Short-term loans with flexible repayment options, which could include lump-sum or EMI repayment plans.
      
      Why It's Important: Gold loans offer a quick way to obtain funds without the need for credit history checks. They are especially useful in emergencies where liquidity is crucial. Additionally, gold loans provide the borrower with the flexibility to repay in easy installments.`,
        },
        {
          title: 'Home Loans',
          content: `A home loan is a long-term secured loan used to purchase a property or home. The property itself acts as collateral for the loan. These loans typically offer larger loan amounts due to the high cost of buying a home and are usually repaid over extended periods.
      
      Loan Amount: Home loans can range from a few lakhs to several crores, depending on the property's value and the borrower’s eligibility.
      
      Interest Rates: Home loans tend to have lower interest rates compared to other types of loans since they are secured by the property.
      
      Repayment Terms: These loans come with long repayment tenures, typically between 15 to 30 years, offering affordable monthly payments.
      
      Why It's Important: Home loans make the dream of owning a house more attainable. Given the high price of property, many individuals cannot afford to buy a home outright and need the support of a loan. Home loans also allow borrowers to spread the cost of a home over many years, making the investment more manageable.`,
        },
        {
          title: 'Personal Loans',
          content: `A personal loan is an unsecured loan that can be used for almost any personal financial need, such as funding a wedding, medical expenses, travel, or home renovation. Since it doesn’t require any collateral, it’s a relatively risk-free option for the borrower, though the interest rates tend to be higher compared to secured loans.
      
      Loan Amount: Generally ranges from a few thousand to several lakhs, depending on the borrower’s creditworthiness and income level.
      
      Interest Rates: Personal loans typically come with higher interest rates compared to secured loans due to the lack of collateral.
      
      Repayment Terms: These loans are usually repaid within a term of 1 to 5 years.
      
      Why It's Important: Personal loans offer flexibility, making them ideal for funding any personal financial needs. Since they are unsecured, you don’t need to provide any property or asset as collateral, but the downside is the higher interest rates.`,
        },
        {
          title: 'Business Loans',
          content: `A business loan is a type of loan designed to meet the financial needs of a business, whether for working capital, expansion, buying new equipment, or managing cash flow. Business loans can be secured or unsecured, and the terms depend largely on the type of business and its financial stability.
      
      Loan Amount: Can vary greatly depending on the type of business, the loan’s purpose, and the borrower’s business financial history. Loan amounts can range from a few lakhs to several crores.
      
      Interest Rates: Typically higher than home or car loans, especially for unsecured business loans. However, the rates can be competitive for businesses with a proven track record.
      
      Repayment Terms: Generally have flexible repayment options, ranging from a few months to several years.
      
      Why It's Important: Business loans provide companies with the funding needed to expand, innovate, or overcome financial challenges. These loans play a vital role in supporting entrepreneurs and helping businesses thrive.`,
        },
        {
          title: 'Education Loans',
          content: `An education loan is a loan specifically designed to help students finance their higher education, whether for tuition fees, books, living expenses, or other related costs. These loans can cover both domestic and international education expenses.
      
      Loan Amount: Varies based on the course and institution, with amounts ranging from a few thousand to lakhs of rupees.
      
      Interest Rates: Education loans tend to have relatively lower interest rates compared to personal loans.
      
      Repayment Terms: These loans often have a long moratorium period, where repayment doesn’t begin until the student completes their studies or secures employment.
      
      Why It's Important: Education loans provide students with the opportunity to pursue higher education, even if they cannot afford to pay the fees upfront. This type of loan is vital for students seeking to advance their skills, improve employability, or pursue professional qualifications.`,
        },
        {
          title: 'Bike Loans',
          content: `A bike loan is a secured loan used to finance the purchase of a motorcycle or scooter. Like a car loan, a bike loan uses the vehicle itself as collateral, which is why these loans generally come with lower interest rates.
      
      Loan Amount: Typically, the loan amount is based on the value of the bike you want to purchase, with the loan amount ranging from a few thousand to lakhs.
      
      Interest Rates: Since bike loans are secured, the interest rates are lower than those of unsecured loans, although they may be higher than car loans.
      
      Repayment Terms: Bike loans typically come with shorter repayment tenures, usually ranging from 1 to 5 years.
      
      Why It's Important: Bike loans help individuals purchase two-wheelers without needing to pay the entire amount upfront. They are popular among younger buyers and those who require an affordable transportation solution.`,
        },
      ];

   
        const reasons = [
          {
            title: "Access to Immediate Capital",
            content: `One of the most significant advantages of loans is that they provide instant access to capital. Many of life’s most significant expenses, such as purchasing a home, car, or paying for medical treatment, require large sums of money that might not be readily available in your savings. While saving up for these goals can take years, loans allow you to fulfill your immediate needs without depleting your savings or waiting to gather funds over a long period.`,
            example: `Example: If you want to buy a car but don’t have enough savings, a car loan lets you access the money needed immediately. You can repay the loan over time with affordable monthly installments, allowing you to enjoy the benefits of your new vehicle right away without waiting until you’ve saved enough.`,
            whyImportant: `Why It’s Important: This access to capital ensures that you don’t miss out on opportunities simply because you don’t have the full amount upfront. Whether it’s a life-changing emergency or a planned purchase, loans help you bridge the gap between your financial capacity and your needs.`,
          },
          {
            title: "Achieving Major Life Goals",
            content: `Major milestones in life often require significant capital that may not be feasible to save up for, especially if you have other ongoing expenses. Loans are a fundamental way to achieve goals like buying a home, starting a business, or pursuing higher education. These life goals can significantly impact your future, but they often require upfront capital that could take years of saving to accumulate.`,
            example: `Example: A home loan allows you to buy your dream home immediately, even though you may not have enough saved. Similarly, an education loan enables you to study in a prestigious institution, giving you the opportunity to build a successful career that would otherwise be out of reach.`,
            whyImportant: `Why It’s Important: Loans help you achieve these significant goals without delaying your progress. You don’t need to wait for years to save enough, as loans empower you to take action now and begin working towards your future aspirations.`,
          },
          {
            title: "Build Credit History",
            content: `A strong credit history is crucial for securing loans at better interest rates in the future. Taking out a loan and repaying it responsibly on time helps you build or improve your credit score. A good credit score demonstrates to lenders that you are financially responsible, which makes it easier for you to access more loans in the future at lower interest rates.`,
            example: `Example: A personal loan or a credit card can be used to build your credit history. When you consistently make on-time payments, your credit score improves, and you become a more attractive borrower to lenders.`,
            whyImportant: `Why It’s Important: Building a positive credit history will not only improve your ability to secure better loan terms but will also give you access to more opportunities. Whether it’s buying a home or starting a business, a strong credit history is the foundation of future financial success.`,
          },
          {
            title: "Tax Benefits",
            content: `Many loans, especially those for large life investments, come with significant tax benefits. Home loans, for instance, are eligible for tax deductions on both principal repayment and interest payments under Section 80C and Section 24(b) of the Income Tax Act in India. Education loans also qualify for tax deductions under Section 80E.`,
            example: `Example: If you take a home loan, the interest you pay is eligible for a tax deduction of up to ₹2 lakh per year, helping you save significantly on your annual tax bill. Similarly, education loans offer tax deductions on the interest paid, making it a cost-effective way to finance higher education.`,
            whyImportant: `Why It’s Important: Tax benefits not only reduce your taxable income but also help lower your overall financial burden. Loans with tax benefits can make high-value expenses more affordable by offering you the ability to save money on taxes.`,
          },
          {
            title: "Affordable Repayments",
            content: `Loans often come with flexible repayment options, allowing you to spread out the cost of your purchase over several years. For example, home loans can be repaid over a 20 to 30-year term, while car loans can have repayment terms of 5 to 7 years. This flexibility means you don’t have to pay a large lump sum amount upfront, which makes it easier to manage your finances and budget effectively.`,
            example: `Example: A home loan with a 30-year term allows you to pay a much smaller monthly amount compared to taking a large sum out of savings, making the purchase manageable even if your income doesn’t immediately support a large expenditure.`,
            whyImportant: `Why It’s Important: The ability to break down large expenses into manageable monthly payments reduces financial stress and ensures that the loan is within your reach. Loans allow you to maintain financial flexibility while achieving your goals.`,
          },
          {
            title: "Capital for Business Growth",
            content: `For entrepreneurs and business owners, business loans are an essential tool for growth and expansion. They provide the necessary funds to invest in infrastructure, hire employees, purchase equipment, and meet working capital needs. Without loans, many businesses would struggle to expand or even survive in competitive markets.`,
            example: `Example:  A business loan could allow a small business to invest in new machinery or technology that increases productivity, or it could help the business hire more employees to meet growing demand.`,
            whyImportant: `Why It’s Important: Business loans provide the capital required to scale operations, expand into new markets, or improve operational efficiency. They are essential for driving economic growth, creating jobs, and fostering innovation.`,
          },
          {
            title: "Financial Flexibility",
            content: `Loans offer an added layer of financial flexibility, allowing you to prioritize essential needs while spreading the repayment over time. This flexibility is critical in managing cash flow effectively, especially when you have multiple financial goals or obligations.`,
            example: `Example: A personal loan can be used to finance a wedding, home renovation, or travel, allowing you to enjoy these experiences now while spreading the cost across several months or years.`,
            whyImportant: `Why It’s Important:  Loans ensure that you don’t have to sacrifice your immediate needs to meet long-term financial obligations. The flexibility to manage your finances through loans helps you balance short-term expenses with long-term savings and investments.`,
          },
          {
            title: "Emergency Funds",
            content: `One of the most common reasons for taking out a loan is to cover urgent or unexpected expenses. Life is unpredictable, and emergencies such as medical treatments, car accidents, or home repairs can arise without warning. Loans, particularly personal loans, offer a quick solution for funding these unforeseen circumstances.`,
            example: `Example: If you suddenly need to pay for medical treatment or repair your car, a personal loan or emergency loan can provide the necessary funds immediately. These loans typically have a fast approval process, helping you manage urgent financial requirements without delays.`,
            whyImportant: `Why It’s Important: Loans serve as a financial safety net during emergencies. They provide you with immediate access to funds, ensuring that you can handle life’s unpredictable challenges without derailing your financial stability.`,
          },
        ];
        const stats = [
            {
              title: "Loan Disbursements in India",
              value: "₹100+ Lakh Crore",
              description:
                "The total loan disbursal by scheduled commercial banks in India is estimated to have exceeded ₹100 lakh crore as of 2023.",
              icon: <FaRupeeSign className="text-4xl text-green-600" />,
              source: "Source: RBI, 2023",
            },
            {
              title: "Loan Penetration Rate",
              value: "25%",
              description:
                "India’s loan penetration rate is relatively low, with only around 25% of the adult population availing of loans. This indicates significant room for growth in the loan market.",
              icon: <FaUserFriends className="text-4xl text-blue-600" />,
              source: "Source: World Bank, 2023",
            },
            {
              title: "Default Rate on Loans",
              value: "7%",
              description:
                "As per the latest reports, non-performing assets (NPAs) in India’s banking sector are hovering around 7%, highlighting the risks associated with loan defaults.",
              icon: <FaExclamationTriangle className="text-4xl text-red-600" />,
              source: "Source: RBI Report, 2023",
            },
          ];
          const loanFactors = [
            {
              title: "Loan Amount and Requirements",
              icon: <FaMoneyCheckAlt className="text-3xl text-indigo-600" />,
              description:
                "Before taking any loan, assess how much money you truly need. Do you need the full loan amount, or can you manage with a smaller loan? Understanding your exact needs will help you avoid borrowing more than necessary, which will reduce interest costs and the financial burden of repayments.",
            },
            {
              title: "Interest Rates",
              icon: <FaPercentage className="text-3xl text-green-600" />,
              description:
                "Interest rates are one of the most important factors to consider when taking out a loan. The rate of interest determines how much you will pay over the life of the loan. Always compare interest rates from different lenders to find the most competitive one. A lower interest rate means lower overall repayment amounts.",
            },
            {
              title: "Loan Tenure",
              icon: <FaCalendarAlt className="text-3xl text-blue-600" />,
              description:
                "The tenure or repayment period of the loan impacts your monthly installment amounts. A longer tenure means lower monthly payments but can result in paying more in interest over time. A shorter tenure will result in higher monthly payments but will reduce the total interest paid. Choose a tenure that fits your budget while balancing long-term financial goals.",
            },
            {
              title: "Processing Fees and Additional Charges",
              icon: <FaFileInvoiceDollar className="text-3xl text-yellow-600" />,
              description:
                "Many lenders charge processing fees or other administrative charges for loan approval. These charges can add up, so ensure you are aware of all the fees involved. Read the loan agreement carefully to avoid any hidden costs or surprises.",
            },
            {
              title: "Prepayment and Foreclosure Terms",
              icon: <FaUnlockAlt className="text-3xl text-rose-600" />,
              description:
                "Some loans may come with penalties for early repayment, while others allow you to pay off the loan faster without additional charges. It’s essential to check the prepayment and foreclosure policies of the lender. Early repayment can reduce your interest liability, so choosing a loan that allows this flexibility can save you money in the long run.",
            },
            {
              title: "Eligibility Criteria",
              icon: <FaIdCard className="text-3xl text-purple-600" />,
              description:
                "Lenders typically set specific eligibility criteria based on income, credit score, employment status, and more. Make sure to verify if you meet the requirements for the loan before applying. Some loans, like personal loans, are based more on credit score, while others like home loans, require proof of stable income and property valuation.",
            },
            {
              title: "Loan Approval and Disbursal Time",
              icon: <FaClock className="text-3xl text-orange-600" />,
              description:
                "For urgent financial needs, the time taken to process and approve a loan can be critical. If you need funds quickly, consider the approval time and how fast the loan will be disbursed after approval. Some loans, such as personal loans or gold loans, offer fast disbursal, while others like home loans may take longer.",
            },
            {
              title: "Loan Type and Flexibility",
              icon: <FaExchangeAlt className="text-3xl text-cyan-600" />,
              description:
                "There are various types of loans with different terms and conditions. Secured loans (like home loans or car loans) require collateral, while unsecured loans (like personal loans) do not. If you are hesitant about risking collateral, unsecured loans may be more suitable, but they often come with higher interest rates.",
            },
          ];

          const loanApprovalFactors = [
            {
              title: "Credit Score",
              description:
                "Your credit score is one of the most critical factors in loan approval. A high credit score indicates that you have a good track record of repaying loans, making you a lower-risk borrower. A low score, on the other hand, may result in higher interest rates or even rejection of your application.",
              icon: <FaRegCreditCard className="text-indigo-600 text-3xl" />,
            },
            {
              title: "Income and Employment Status",
              description:
                "Lenders assess your income and employment stability to ensure that you can afford the loan repayment. Those with stable, regular incomes are often more likely to be approved for loans. Self-employed individuals may need to provide additional documentation to prove income stability.",
              icon: <FaBriefcase className="text-green-600 text-3xl" />,
            },
            {
              title: "Existing Debt",
              description:
                "If you already have other loans or significant debt, it can affect your eligibility for a new loan. Lenders may be hesitant to approve loans to individuals with high debt-to-income ratios, as this indicates a higher risk of defaulting.",
              icon: <FaBalanceScale className="text-blue-600 text-3xl" />,
            },
            {
              title: "Collateral Offered (for Secured Loans)",
              description:
                "If you are applying for a secured loan (like a home or car loan), the lender will evaluate the collateral you offer. The value of the asset (e.g., your home or vehicle) plays a crucial role in loan approval. The asset must be valuable enough to cover the loan amount in case of default.",
              icon: <FaHome className="text-yellow-600 text-3xl" />,
            },
            {
              title: "Loan Type",
              description:
                "Certain loan types are riskier for lenders, such as personal loans, due to their unsecured nature. Depending on the loan type, the lender may require higher interest rates or more stringent terms.",
              icon: <FaHandshake className="text-rose-600 text-3xl" />,
            },
            {
              title: "Age and Experience",
              description:
                "For business loans, the age and experience of the business owner can also be a deciding factor. Businesses with a solid track record and years of operation are more likely to secure loans at favorable terms.",
              icon: <FaUniversity className="text-purple-600 text-3xl" />,
            },
            {
              title: "Property Value (for Home Loans)",
              description:
                "When applying for a home loan, the lender will evaluate the market value of the property you intend to purchase. If the property’s value is deemed sufficient to cover the loan amount, the chances of approval increase.",
              icon: <FaHome className="text-teal-600 text-3xl" />,
            },
            {
              title: "Documentation",
              description:
                "The completeness and accuracy of the documents you submit will also impact the loan approval process. Lenders require detailed documents related to your income, assets, liabilities, and identification to verify your financial standing.",
              icon: <FaFileSignature className="text-orange-600 text-3xl" />,
            },
          ];

          const finMasterFeatures = [
            {
              title: "Curated Loan Comparisons",
              icon: <FaChartBar className="text-3xl text-violet-600" />,
              description:
                "Finding the right loan is all about making comparisons across various lenders and loan products. At FinMaster, we offer curated side-by-side loan comparisons that allow you to assess loans based on key parameters such as loan amounts, interest rates, tenure, repayment terms, and other important features. Our comparisons help you easily evaluate your options and choose the most competitive loan.",
              howItHelps:
                "Instead of browsing through multiple websites and aggregating information yourself, FinMaster does the hard work for you. By displaying the loan details in a clear, comparative format, we enable you to make smarter, more efficient choices based on your specific financial situation.",
              example:
                "If you’re comparing home loans across different lenders, FinMaster will show you key differences in interest rates, repayment options, and eligibility criteria. You can instantly identify which lender offers the best deal that aligns with your budget and needs.",
            },
            {
              title: "Expert Advice and Guidance",
              icon: <FaHandsHelping className="text-3xl text-emerald-600" />,
              description:
                "Navigating the world of loans can be a complex and daunting task, especially if it’s your first time applying for one. At FinMaster, we offer expert advice and guidance throughout the loan process. Our team of seasoned financial professionals is here to assist you with selecting the best loan, explaining the fine print of loan agreements, and helping you avoid common pitfalls.",
              howItHelps:
                "Whether you're unsure which type of loan to apply for (such as personal loans, business loans, or car loans) or need assistance understanding hidden fees, EMIs, or interest rate structures, our experts provide valuable, unbiased advice tailored to your needs.",
              example:
                "Suppose you’re considering a personal loan but are unclear about the difference between fixed-rate and floating-rate interest. Our experts will walk you through the pros and cons of each option, ensuring that you understand how your loan will be structured.",
            },
            {
              title: "Loan Calculators",
              icon: <FaCalculator className="text-3xl text-rose-600" />,
              description:
                "One of the most valuable tools that FinMaster offers is our collection of loan calculators. These user-friendly calculators help you estimate your potential EMI payments, total repayment amounts, interest costs, and even determine the overall affordability of a loan. By entering details like the loan amount, interest rate, and tenure, you can quickly gauge your financial commitment before applying.",
              howItHelps:
                "Loan calculators take the guesswork out of planning your finances. They help you understand what the loan will cost you monthly, as well as how the total repayment sum will look after interest is factored in.",
              example:
                "If you’re planning to take a home loan of ₹50 lakh at an interest rate of 8% for a tenure of 20 years, our EMI calculator will instantly show you how much your monthly payment will be, as well as the total cost of the loan over its full term.",
            },
            {
              title: "Updated Loan Blogs and Articles",
              icon: <FaBookOpen className="text-3xl text-blue-600" />,
              description:
                "At FinMaster, we understand that the world of loans is constantly evolving, with new trends, regulations, and options emerging frequently. That’s why we provide a comprehensive library of updated blogs and articles designed to keep you informed about the latest loan industry news and best practices.",
              howItHelps:
                ": Our content serves as an educational resource that guides you through the loan selection process. From tips on how to improve your chances of loan approval to in-depth explanations of loan types, we help you stay updated on everything you need to know to make smarter financial decisions.",
              example:
                "Our loan blogs cover essential topics such as how to choose the right home loan based on market trends, how to improve your credit score for loan eligibility, and even how to negotiate better loan terms. This empowers you with knowledge so that you are always one step ahead in your loan journey.",
            },
            {
              title: "Personalized Loan Filters",
              icon: <FaSlidersH className="text-3xl text-yellow-600" />,
              description:
                "FinMaster’s platform allows you to filter and search for loan options that perfectly align with your unique needs. Our personalized loan filters enable you to narrow down loan products based on key factors such as loan amount, interest rates, loan tenure, and eligibility requirements. This ensures that you only see the most relevant loan options for your specific financial situation.",
              howItHelps:
                "Instead of sifting through hundreds of loan options that may not be right for you, our filters streamline your search, helping you focus on loans that are best suited for your income level, credit score, and financial goals. This saves you time and effort, ultimately guiding you to the most suitable choices.",
              example:
                "If you are looking for a business loan with a tenure of 5 years, a low interest rate, and a maximum loan amount of ₹10 lakh, our filters will only show loans that match these criteria, eliminating unnecessary options.",
            },
            {
              title: "Transparent and Unbiased Reviews",
              icon: <FaRegComments className="text-3xl text-indigo-600" />,
              description:
                "One of the most crucial aspects of choosing the right loan is knowing the experiences of others who have used the loan products you’re considering. FinMaster provides authentic, verified reviews from real customers who have experienced various loan products firsthand. These reviews offer valuable insights into how easy or difficult the loan process was, how well the lender handled customer service, and whether the loan terms were fair and reasonable.",
              howItHelps:
                "Our unbiased reviews help you understand the strengths and weaknesses of different loan products. With real customer experiences at your disposal, you can make well-informed decisions based on the feedback from others who have already been through the process.",
              example:
                "If you are considering an education loan for your child’s higher education, FinMaster’s customer reviews will help you understand the application process, the lender’s response time, and any hidden fees that may have come up during the process. This insight helps you avoid lenders with poor customer service or problematic loan terms.",
            },
          ];
          const ad = {
            image: "/assets/homeadd.png",
            link: "https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share",
            altText: "Advertisement",
          };
  return (
    <>
      <Helmet>
        <title>Compare Loans in India – Personal, Home, Car & More</title>
        <meta 
          name='description' 
          content='Explore loan options including personal, home, car, and education loans. Compare interest rates and apply online.'
        />
      
        <link rel="canonical" href="https://thefinmaster.com/loan" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
<FAQSchema faqs={faqs} />
<div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
      <nav className="text-gray-500 text-sm my-4 ml-10 mt-10" aria-label="Breadcrumb">
           <ol className="list-none p-0 inline-flex">
             <li className="flex items-center">
               <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
               <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                 <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
               </svg>
             </li>
               <li className="flex items-center">
               <span className="text-gray-500 ">Loan Page</span>
             </li> 
         
           </ol>
         </nav>
       
         <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600 ">
                  Discover personalized loan solutions crafted 
                  </span>{" "}
                  just for you by leading lenders.
                </h1>
                {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full"
                src="../assets/la.png"
                alt="car-loan"
              />
            </div>
          </div>
       </div>
       <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
    <p className="text-lg md:text-base lg:text-lg text-center">
    In our fast-paced society, convenience is essential. Loans offer a practical solution, merging easy application processes with substantial financial aid. Don’t worry about funding challenges – a well-selected loan ensures you have the resources for your needs. The benefits extend beyond convenience. At TheFinMaster.com, we’ll guide you through the complex loan market to find the ideal option for your financial requirements. </p>
    </div>
            <div >

            </div>
        </div>
        <div className="w-full flex justify-center items-center my-6 px-4">
          <div
           
            className="w-full max-w-5xl"
          >
           <AdBanner displayOrder="2" />
          </div>
        </div>
      <h2 className='text-center text-2xl md:text-2xl lg:text-3xl font-bold my-10'>Featured Loan Cards</h2>
            <div className=" flex items-center justify-center">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 px-4 py-2">
  {cardDataS.map((card, index) => (
    <motion.div
      key={index}
      className="flex flex-col justify-between relative rounded-lg overflow-hidden shadow-lg border border-gray-200 w-full h-full"
      whileHover={{ scale: 1.05 }}
      transition={{ duration: 0.3 }}
    >
      {/* Type Badge */}
      <div className="absolute top-2 left-2 bg-blue-600 text-white text-xs px-3 py-1 rounded-full shadow-md z-10">
        {card.type.toUpperCase()}
      </div>

      {/* Image */}
      <img
        className="w-full h-36 object-contain p-4"
        src={card.imageUrl}
        alt={card.title}
      />

      {/* Card Content */}
      <div className="flex-grow px-4 pb-2">
        <div className="font-bold text-lg mb-1 text-center text-blue-500">
          {card.title}
        </div>
        {renderCardDetails(card)}
      </div>

      {/* Action Buttons */}
      <div className="flex justify-center gap-3 py-3 px-4 mt-auto">
        <a
          className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-1 px-3 rounded-full text-sm transition duration-300"
          href={card.learnMoreLink}
          target="_blank"
          rel="noreferrer"
        >
         See Details
        </a>
        <a
          className="bg-green-500 hover:bg-green-700 text-white font-medium py-1 px-3 rounded-full text-sm transition duration-300"
          href={card.applyNowLink}
          target="_blank"
          rel="noreferrer"
        >
          Apply Now
        </a>
      </div>
    </motion.div>
  ))}
</div>

      {/* <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 ">
        {cardDataS.map((card, index) => (
          <motion.div 
            key={index} 
            className="rounded-lg overflow-hidden shadow-lg border border-gray-200 max-w-xs"
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <img
              className="w-full"
              src={card.imageUrl}
              alt={card.title} 
            />
            <div className="px-3 py-2">
              <div className="font-bold text-lg mb-1 text-center text-blue-500">{card.title}</div>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Joining Fee:</strong> {card.premiumStarting}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Rewards Rate:</strong> {card.claimSettlement}</p>
              <p className="text-gray-600 text-base text-center mt-2"><strong>Rewards Rate:</strong> {card.networkGarages}</p>

            </div>
            <div className="flex justify-center py-2">  
            <a      
                className="bg-blue-500 hover:bg-blue-700 text-white font-medium py-1 px-3 rounded-full mr-2 text-sm transition duration-300 ease-in-out"
                href={card.learnMoreLink}
                target= "blank"
                rel="nofollow"
              > 
                View Card
              </a>
              <a
                className="bg-green-500 hover:bg-green-700 text-white font-medium py-1 px-3 rounded-full text-sm transition duration-300 ease-in-out"
                href={card.applyNowLink}
                target= "blank"
                rel="nofollow"
              >
                Apply Now
              </a>
            </div>
          </motion.div>
        ))}
      </div> */}

    </div>


     <div className="flex justify-center items-center  p-4 mt-4">
          <motion.div 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.5 }}
            className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-2">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">What is a Loan?</h2>
            <p className="text-gray-600 leading-relaxed">
            A loan is a financial instrument that allows an individual or business to borrow money from a lender (typically a bank, financial institution, or credit union) under an agreement to repay the borrowed amount along with interest over a specified period.            </p>
            <p className="text-gray-600 leading-relaxed mt-3">
            Loans are crucial in helping individuals and businesses meet their financial needs when they don’t have enough funds upfront. There are various types of loans available, each designed for specific needs, such as personal expenses, purchasing a home or car, business expansion, or funding education.            </p>
            <p className="text-gray-600 leading-relaxed mt-3">When you borrow money, you enter into a contract that binds you to repay the loan in installments (usually monthly) over the agreed-upon term. Failure to repay on time can lead to penalties, damaged credit scores, and legal action. Hence, it’s important to understand the loan terms thoroughly before committing.</p>
          </motion.div>
        </div>
        <section className="max-w-7xl mx-auto px-4 py-10">
      <h2 className="text-2xl md:text-3xl font-bold text-center text-blue-700 mb-6">
        📌 Important Types of Loans
      </h2>
      <p className="text-center text-gray-600 mb-10">
        Loans are essential financial products that help individuals and businesses meet specific financial needs, from purchasing assets like homes and cars to funding personal projects or business ventures. Understanding the different types of loans available can help you choose the one that best aligns with your needs, financial situation, and long-term goals. Below are the most common types of loans and a comprehensive breakdown of what they offer.
      </p>

      {/* <div className="space-y-10">
        {loanData.map((loan, index) => (
          <div
            key={index}
            className="bg-white shadow-md border border-gray-200 rounded-xl p-6 hover:shadow-xl transition duration-300"
          >
            <h2 className="text-2xl font-semibold text-blue-800 mb-4">{loan.title}</h2>
            {loan.content.split('\n').map((para, i) => (
              <p key={i} className="text-gray-700 mb-3 whitespace-pre-line">
                {para}
              </p>
            ))}
          </div>
        ))}
      </div> */}
        {/* <div className="space-y-10">
        {loanData.map((loan, index) => (
          <div
            key={index}
            className="bg-white shadow-md border border-gray-200 rounded-xl p-6 hover:shadow-xl transition duration-300"
          >
            <h2 className="text-2xl font-semibold text-blue-800 mb-4">{loan.title}</h2>
            {loan.content &&
              loan.content.split('\n').map((para, i) => {
                const match = para.match(/^([\w\s']+?):\s*(.*)/);
                return (
                  <p key={i} className="text-gray-700 mb-3 whitespace-pre-line">
                    {match ? (
                      <>
                        <span className="font-semibold text-blue-700">{match[1]}:</span>{' '}
                        {match[2]}
                      </>
                    ) : (
                      para
                    )}
                  </p>
                );
              })}
          </div>
        ))}
      </div> */}
       <div className="space-y-6">
        {loanData.map((loan, index) => (
          <div key={index} className="border border-gray-300 rounded-xl overflow-hidden">
            {/* Header */}
            <div
              className="bg-blue-100 px-4 py-3 cursor-pointer md:cursor-default flex justify-between items-center"
              onClick={() => isMobile && toggleAccordionNew(index)}
            >
              <h2 className="text-lg font-semibold text-blue-800">{loan.title}</h2>
              <span className="md:hidden text-xl text-blue-600">
                {activeIndexNew === index ? '-' : '+'}
              </span>
            </div>

            {/* Content - Always visible on desktop, collapsible on mobile */}
            <div
              className={`px-4 py-3 bg-white transition-all duration-300 ${
                isMobile
                  ? activeIndexNew === index
                    ? 'block'
                    : 'hidden'
                  : 'block'
              }`}
            >
              {renderParagraphs(loan.content)}
            </div>
          </div>
        ))}
      </div>
    </section>


    <div className="bg-gradient-to-b from-white to-gray-100 py-4 px-6 md:px-16 text-gray-800">
      <h2 className="text-2xl md:text-3xl font-bold text-center text-blue-700 mb-6">
        📌 Why Loan Can Be Important?
      </h2>
      <p className="text-lg text-center max-w-4xl mx-auto mb-6">
      Loans are not just about borrowing money; they serve as essential financial tools that can help individuals and businesses achieve goals, manage financial emergencies, and plan for a secure future. By borrowing money in the right manner, you can overcome financial barriers and make significant strides in your personal and professional life. Here are some reasons why loans are incredibly important:      </p>

      <div className="space-y-12">
        {reasons.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row gap-6 bg-white p-6 md:p-10 rounded-2xl shadow-md border-l-8 ${
              index % 2 === 0 ? "border-blue-500" : "border-indigo-500"
            }`}
          >
            <div className="flex-shrink-0 text-blue-600 text-2xl md:text-3xl font-bold flex items-start justify-center md:justify-start">
              {index + 1 < 10 ? `0${index + 1}` : index + 1}
            </div>

            <div className="flex-1 space-y-4">
              <h3 className="text-2xl font-semibold text-blue-600 flex items-center gap-2">
                <FaCheckCircle className="text-green-500" /> {item.title}
              </h3>
              <p className="text-gray-700 leading-relaxed">{item.content}</p>
              <p className="text-gray-900 font-medium italic">{item.example}</p>
              <p className="bg-blue-50 border-l-4 border-blue-400 p-4 rounded-md text-blue-900 font-semibold">
                {item.whyImportant}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
    <div className=" py-14 px-6 md:px-20">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-12">
        📊 Important Stats on Loans (India)
      </h2>

      <div className="grid gap-8 md:grid-cols-3">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-2xl p-6 border-t-4 border-blue-400 hover:shadow-xl transition-all"
          >
             
            <div className="flex items-center gap-4 mb-4">
              <div className="bg-purple-100 p-4 rounded-full">{stat.icon}</div>
              <div>
                <h3 className="text-xl font-semibold text-gray-800">
                  {stat.title}
                </h3>
                <p className="text-sm text-gray-500 italic">{stat.source}</p>
              </div>
            </div>
            <p className="text-2xl font-bold text-blue-700 mb-3">{stat.value}</p>
            <p className="text-gray-700 leading-relaxed">{stat.description}</p>
          </div>
        ))}
      </div>
    </div>
    <section className="bg-slate-50 py-14 px-6 md:px-16">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-10">
        📌 Factors to Consider Before Choosing a Loan
      </h2>
      <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">
        Choosing the right loan is a crucial decision that can significantly impact your financial health. Here are some important factors you should consider before taking a loan:
      </p>

      <div className="grid gap-8 md:grid-cols-2">
        {loanFactors.map((factor, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-2xl shadow-md border-l-4 border-blue-500 hover:shadow-xl transition"
          >
            <div className="flex items-start gap-4 mb-3">
              <div className="p-3 bg-indigo-100 rounded-full">{factor.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800">
                {factor.title}
              </h3>
            </div>
            <p className="text-gray-700 leading-relaxed">{factor.description}</p>
          </div>
        ))}
      </div>
    </section>
    <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
    <section className="bg-white py-14 px-6 md:px-8">
      <h2 className="text-4xl font-bold text-center text-blue-600 mb-10">
        📌 Factors Affecting Loan Approval and Terms
      </h2>
      <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">
        Several factors can influence whether your loan application is approved and the terms of the loan. Here are some key elements that lenders evaluate:
      </p>

      {/* <div className="relative border-l-4 border-indigo-300 ml-4"> */}
        {loanApprovalFactors.map((factor, index) => (
          <div key={index} className="mb-10 ml-6">
            <div className="flex items-center mb-2">
              <div className="bg-indigo-100 rounded-full p-3 mr-4">
                {factor.icon}
              </div>
              <h3 className="text-2xl font-semibold text-gray-800">{factor.title}</h3>
            </div>
            <p className="text-gray-700 leading-relaxed pl-16">{factor.description}</p>
          </div>
        ))}
      {/* </div> */}
    </section>
    {/* <section className="bg-white py-14 px-6 md:px-16">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-10">
        📌 How FinMaster Helps in Choosing the Right Loan
      </h2>
      <p className="text-center text-gray-600 max-w-3xl mx-auto mb-12">
      At FinMaster, our mission is to simplify the often overwhelming process of choosing the right loan. With a wide range of loan products available, it can be challenging to determine which one best suits your financial needs. We strive to provide all the tools, information, and expert advice you need to make informed, confident decisions. Here’s how FinMaster ensures you choose the right loan every time:      </p>

      <div className="grid gap-10 md:grid-cols-2">
        {finMasterFeatures.map((feature, index) => (
          <div
            key={index}
            className="bg-gray-50 p-6 rounded-2xl shadow hover:shadow-lg transition border-t-4 border-blue-500"
          >
            <div className="flex items-start gap-4 mb-4">
              <div className="p-3 bg-indigo-100 rounded-full">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-800">
                {feature.title}
              </h3>
            </div>
            <p className="text-gray-700 mb-3">{feature.description}</p>
            <p className="text-sm text-gray-600 mb-2">
              <span className="font-medium text-blue-600">How It Helps:</span>{" "}
              {feature.howItHelps}
            </p>
            <p className="text-sm text-gray-600">
              <span className="font-medium text-blue-600">Example:</span>{" "}
              {feature.example}
            </p>
          </div>
        ))}
      </div>
    </section> */}
    {/* <section className="bg-white py-20 px-6 md:px-16">
  <div className="max-w-6xl mx-auto text-center">
    <h2 className="text-4xl font-bold text-blue-700 mb-6">
      📌 How FinMaster Helps in Choosing the Right Loan
    </h2>
    <p className="text-gray-600 text-lg max-w-3xl mx-auto mb-14">
      Choosing the right loan can feel overwhelming — but not with FinMaster. We guide you through the process with clarity, insight, and smart tools so you always make informed decisions.
    </p>
  </div>

  <div className="relative border-l-4 border-blue-200 ml-4 md:ml-0">
    {finMasterFeatures.map((feature, index) => (
      <div
        key={index}
        className={`relative mb-14 pl-10 md:pl-16 max-w-4xl ${
          index % 2 === 1 ? "md:ml-auto md:pr-16" : ""
        }`}
      >
        <div className="absolute -left-5 top-1 bg-blue-200 text-white w-10 h-10 flex items-center justify-center rounded-full shadow-lg">
          {feature.icon}
        </div>
        <h3 className="text-xl font-semibold text-gray-800 mb-2">
          {feature.title}
        </h3>
        <p className="text-gray-700 mb-3">{feature.description}</p>
        <p className="text-sm text-gray-600 mb-1">
          <span className="font-medium text-blue-600">How It Helps:</span> {feature.howItHelps}
        </p>
        <p className="text-sm text-gray-600">
          <span className="font-medium text-blue-600">Example:</span> {feature.example}
        </p>
      </div>
    ))}
  </div>
</section> */}
<section className="bg-white py-8 px-6 md:px-16">
  <div className="max-w-6xl mx-auto text-center mb-16">
    <h2 className="text-3xl font-bold text-blue-700 mb-4">
      📌 How FinMaster Helps in Choosing the Right Loan
    </h2>
    <p className="text-gray-600  max-w-3xl mx-auto">
    At FinMaster, our mission is to simplify the often overwhelming process of choosing the right loan. With a wide range of loan products available, it can be challenging to determine which one best suits your financial needs. We strive to provide all the tools, information, and expert advice you need to make informed, confident decisions. Here’s how FinMaster ensures you choose the right loan every time:
    </p>
  </div>

  <div className="space-y-16 max-w-7xl mx-auto">
    {finMasterFeatures.map((feature, index) => (
      <div key={index} className="relative pl-14">
        <div className="absolute left-0 top-0 w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold text-lg shadow-md">
          {index + 1}
        </div>
        <h3 className="text-2xl font-semibold text-gray-800 mb-2">
          {feature.title}
        </h3>
        <p className="text-gray-700 mb-2">{feature.description}</p>
        <p className="text-base text-gray-600 mb-1">
          <span className="font-medium text-blue-600">How It Helps:</span> {feature.howItHelps}
        </p>
        <p className="text-base text-gray-600">
          <span className="font-medium text-blue-600">Example:</span> {feature.example}
        </p>
      </div>
    ))}
  </div>
</section>

             {/* FAQ section */}
    <div className="max-w-4xl mx-auto py-6 mt-10 px-2">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
    </>
  );
}

export default LoanInsuranceNewUiHome;
